export default __webpack_public_path__ + "static/media/passwordSVG.e2d639f1.svg";